export default [
  {
    component: 'CNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    component: 'CNavGroup',
    name: 'Data Mahasiswa',
    to: '/data-mahasiswa',
    icon: 'cil-description',
    items: [
      {
        component: 'CNavItem',
        name: 'Mahasiswa',
        to: '/data-mahasiswa/mahasiswa',
      },
      {
        component: 'CNavItem',
        name: 'Update Biodata',
        to: '/data-mahasiswa/update-biodata',
      },
      {
        component: 'CNavItem',
        name: 'History Pendidikan',
        to: '/data-mahasiswa/history-pendidikan',
      },
      {
        component: 'CNavItem',
        name: 'Nilai Transfer',
        to: '/data-mahasiswa/nilai-transfer',
      },
      {
        component: 'CNavItem',
        name: 'Prestasi',
        to: '/data-mahasiswa/prestasi',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Kurikulum',
    to: '/kurikulum',
    icon: 'cil-book',
    items: [
      {
        component: 'CNavItem',
        name: 'Data Kurikulum',
        to: '/kurikulum/data-kurikulum',
      },
      {
        component: 'CNavItem',
        name: 'Mata Kuliah',
        to: '/kurikulum/mata-kuliah',
      },
      {
        component: 'CNavItem',
        name: 'Matkul Kurikulum',
        to: '/kurikulum/matkul-kurikulum',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Kelas Kuliah',
    to: '/kelas-kuliah',
    icon: 'cil-room',
    items: [
      {
        component: 'CNavItem',
        name: 'Daftar Kelas Kuliah',
        to: '/kelas-kuliah/daftar-kelas-kuliah',
      },
      {
        component: 'CNavItem',
        name: 'Komponen Evaluasi',
        to: '/kelas-kuliah/komponen-evaluasi',
      },
      {
        component: 'CNavItem',
        name: 'Ajar Dosen',
        to: '/kelas-kuliah/ajar-dosen',
      },
      {
        component: 'CNavItem',
        name: 'KRS',
        to: '/kelas-kuliah/krs',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Nilai Kuliah',
    to: '/nilai-kuliah',
    icon: 'cil-pencil',
    items: [
      {
        component: 'CNavItem',
        name: 'Daftar Nilai Kuliah',
        to: '/nilai-kuliah/daftar-nilai-kuliah',
      },
      {
        component: 'CNavItem',
        name: 'Nilai Komponen Evaluasi',
        to: '/nilai-kuliah/nilai-komponen-evaluasi',
      },
    ],
  },
  // {
  //   component: 'CNavGroup',
  //   name: 'Pelengkap',
  //   to: '/pelengkap',
  //   icon: 'cil-chat-bubble',
  //   items: [
  //     {
  //       component: 'CNavItem',
  //       name: 'Skala Nilai',
  //       to: '/pelengkap/skala-nilai',
  //     },
  //     {
  //       component: 'CNavItem',
  //       name: 'Periode Perkuliahan',
  //       to: '/pelengkap/periode-perkuliahan',
  //     },
  //   ],
  // },
  {
    component: 'CNavGroup',
    name: 'Sistem',
    to: '/sistem',
    icon: 'cil-settings',
    items: [
      {
        component: 'CNavItem',
        name: 'Data Pengguna',
        to: '/sistem/data-pengguna',
      },
    ],
  },
]
